type LogoutFunction = () => void;

interface TokenManager {
  token: string;
  refreshToken: string;
  logout: Array<LogoutFunction>;
  setToken: (token: string) => void;
  setRefreshToken: (refreshToken: string) => void;
  setLogoutMethod: (logout: LogoutFunction) => void;
  doLogout: () => void;
}

export const tokenManager: TokenManager = {
  token: '',
  refreshToken: '',
  logout: [],
  setToken(t: string) {
    this.token = t;
  },
  setRefreshToken(t: string) {
    this.refreshToken = t;
  },
  setLogoutMethod(m) {
    this.logout = [m];
  },
  doLogout() {
    this.logout.forEach((i: LogoutFunction) => i());
  },
};
